import { render, staticRenderFns } from "./Vistorias.vue?vue&type=template&id=6529c5ba&"
import script from "./Vistorias.vue?vue&type=script&lang=js&"
export * from "./Vistorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports